import { render, staticRenderFns } from "./ControleUsuarios.vue?vue&type=template&id=4f791a36&"
import script from "./ControleUsuarios.vue?vue&type=script&lang=js&"
export * from "./ControleUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./ControleUsuarios.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports